import { CommissionApi } from '@/apis';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { TableState } from '@tanstack/react-table';
import { ResponseData } from '@/types/http';
import { Commission } from '@/types/commission';

export default class CommissionStore extends BaseStore {
    api: CommissionApi;

    commissions: Commission[] = [];
    total: number | string | undefined = undefined;
    totalRevenueCommission: number | string | undefined = undefined;
    totalCommission: number | string | undefined = undefined;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            commissions: observable,
            totalCommission: observable,
            getCommissions: flow.bound,
            exportFileCommissionExcel: flow.bound,
            exportFileCommissionPdf: flow.bound
        });
        this.api = new CommissionApi();
    }

    *getCommissions(searchParams?: any, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getCommissions,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res.ok) {
                this.total = res.data.total;
                this.totalRevenueCommission = res.data.totalRevenueCommission;
                this.totalCommission = res.data.totalCommission;

                this.commissions = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.paginate)
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) {
        }
    }

    *exportFileCommissionExcel(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.exportFileCommissionExcel,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    *exportFileCommissionPdf(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.exportFileCommissionPdf,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res) {
                return res;
            }
            return false;
        } catch (error) {
            return false;
        }
    }

    clean(): void {
        super.clean();

        this.commissions = [];
        this.total = undefined;
        this.totalRevenueCommission = undefined;
        this.totalCommission = undefined;
    }
}
